module.exports = __webpack_public_path__ + "img/logo.dd31b42f.png";